import axios from "@/libs/api.request";
// 获取列表
export const getBranchCod = data => {
  return axios.request({
    url: "/finance/branch/cod/outbound/list",
    method: "post",
    data
  });
};
// 基础数据
export const getSearchConfig = params => {
  return axios.request({
    url: "/finance/branch/cod/outbound/config",
    method: "get",
    params
  });
};

// 批量备注
export const batchRemarks = data => {
  return axios.request({
    url: "/finance/branch/cod/outbound/batchRemarks",
    method: "post",
    data
  });
};

// 批量挂起
export const batchHang = data => {
  return axios.request({
    url: "/finance/branch/cod/outbound/batchException",
    method: "post",
    data
  });
};

// 批量取消挂起
export const batchCancelHang = data => {
  return axios.request({
    url: "/finance/branch/cod/outbound/cancelHangStatus",
    method: "post",
    data
  });
};

// 生成应收账单
export const createBranchBill = data => {
  return axios.request({
    url: "/finance/branch/cod/outbound/createAgentCheckBill",
    method: "post",
    data
  });
};

// 生成应退账单
export const createClientBill = data => {
  return axios.request({
    url: "/finance/branch/cod/outbound/createClientCheckBill",
    method: "post",
    data
  });
};

export const sync = params => {
  return axios.request({
    url: "/finance/cod/branch/order/sync",
    method: "get",
    params
  });
};